import Settings from 'configs/Settings';
import isNil from 'lodash/isNil';
import { DatahubEventsService } from 'modules/app/services';
import {
  ViewDeviceFileUploadSchema,
  ViewMembershipFileUploadSchema
} from 'modules/app/services/datahubEvents/attachment';
import {
  ViewDeviceMediaUploadSchema,
  ViewMembershipMediaUploadSchema
} from 'modules/app/services/datahubEvents/media';

import {
  ASYNC_IMAGE_INTERVAL,
  ASYNC_IMAGE_MAX_TRIALS,
  DEFAULT_PROFILE_THUMBNAIL_SIZE,
  CONFIG_URL,
  ENTITY_DATA_TYPE,
  FILES_SYSTEM,
  FILES_URL,
  VALID_FILE_REQUEST_STATUS,
  ENTITY_TYPE
} from './constants';
import { UploadOrigin } from './types';

const getUploaderConfig = (type = '', accessToken, subdomain) => ({
  config: {
    url: CONFIG_URL,
    type
  },
  accessToken,
  authParams: {
    Club: subdomain
  },
  subdomain,
  system: FILES_SYSTEM
});

function getFileLink(fileId) {
  if (isNil(fileId)) {
    return null;
  }

  const fileLink = `${FILES_URL}/${fileId}`;

  return fileLink;
}

function blobToFile(blob, name, lastModified, type) {
  const file = new Blob([blob], { type });

  file.lastModifiedDate = lastModified;
  file.name = name;
  return file;
}

function isVideo(media) {
  const { entityInfo = {}, playerKey, playerMedia = {} } = media;
  const hasTypeMedia =
    entityInfo.type &&
    entityInfo.type.indexOf(`_${ENTITY_DATA_TYPE.MEDIA}`) > 0;

  return playerKey || playerMedia.playerKey || hasTypeMedia;
}

function waitAsyncImage(url, successCallback, errorCallback) {
  let trials = 0;

  const interval = setInterval(() => {
    if (trials < ASYNC_IMAGE_MAX_TRIALS) {
      fetch(url)
        .then((response) => {
          if (VALID_FILE_REQUEST_STATUS.includes(response.status)) {
            clearInterval(interval);
            successCallback();
          } else {
            trials += 1;
          }
        })
        .catch(() => {
          clearInterval(interval);
          errorCallback();
        });
    } else {
      clearInterval(interval);
      errorCallback();
    }
  }, ASYNC_IMAGE_INTERVAL);
}

const imageThumbnailApi = `${Settings.api.thumbor}/imageThumbnail`;

const pictureThumbUrl = (
  pictureThumbId,
  height = DEFAULT_PROFILE_THUMBNAIL_SIZE.height,
  width = DEFAULT_PROFILE_THUMBNAIL_SIZE.width
) =>
  `${imageThumbnailApi}?fmID=${pictureThumbId}&height=${height}&width=${width}`;

const sendDatahubEvent = (origin, entityType) => {
  const schemaCreators = {
    [ENTITY_TYPE.PAGE_ATTACHMENT]: {
      [UploadOrigin.Membership]: () =>
        new ViewMembershipFileUploadSchema({
          arrivedFrom: window.location.href,
          origin
        }),
      [UploadOrigin.Device]: () =>
        new ViewDeviceFileUploadSchema({
          arrivedFrom: window.location.href
        })
    },
    [ENTITY_TYPE.PAGE_MEDIA]: {
      [UploadOrigin.Membership]: () =>
        new ViewMembershipMediaUploadSchema({
          arrivedFrom: window.location.href,
          origin
        }),
      [UploadOrigin.Device]: () =>
        new ViewDeviceMediaUploadSchema({
          arrivedFrom: window.location.href
        })
    }
  };

  const entitySchemas = schemaCreators[entityType];

  if (!entitySchemas) {
    return null;
  }

  const schema = entitySchemas[origin]
    ? entitySchemas[origin]()
    : entitySchemas.default();

  if (schema) {
    DatahubEventsService.sendEvent({ schema });
  }
};

export {
  blobToFile,
  getFileLink,
  getUploaderConfig,
  isVideo,
  pictureThumbUrl,
  waitAsyncImage,
  sendDatahubEvent
};
